export default __webpack_public_path__ + "static/media/IC00037-favorite_org.635eb2d1.svg";